import React, { Component } from "react";
import { connect } from "react-redux";
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import StaffingLevelEditModal, { STAFFING_LEVEL_MODAL_STYLE } from "components/StaffingLevels/StaffingLevelEditModal";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as groupsActions from "actions/groupsActions";
import { staffingLevelsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";

class StaffingLevelList extends Component {
	constructor(props) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditStaffingLevelModal =
			this.openEditStaffingLevelModal.bind(this);
		this.openDeleteStaffingLevelModal =
			this.openDeleteStaffingLevelModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openEditStaffingLevelModal(staffing_level) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('staffingLevels.editModal'),
				style: STAFFING_LEVEL_MODAL_STYLE,
				content: (
					<StaffingLevelEditModal
						staffing_level={staffing_level}
						handleClose={this.closeModal}
						getStaffingLevels={this.props.getStaffingLevels}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteStaffingLevelModal(idStaffingLevel) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('staffingLevels.deleteModal'),
				style: { maxWidth: "550px", width: "100%" },
				message: this.props.t('staffingLevels.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(idStaffingLevel),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message, title = this.props.t('staffingLevels.deleteError')) {
		this.props.showModal(
			{
				open: true,
				title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idStaffingLevel) => {
		const response = await staffingLevelsService.remove(idStaffingLevel);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				textError.id || textError.general || this.props.t('staffingLevels.deleteErrorMsg')
			);
		} else {
			this.props.getStaffingLevels();
			this.closeModal();
		}
	};

	cloneStaffingLevel = async (idStaffingLevel) => {
		const response = await staffingLevelsService.clone(idStaffingLevel);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				textError.general || textError.id || this.props.t('staffingLevels.cloneErrorMsg'),
				this.props.t('staffingLevels.cloneError')
			);
		} else {
			this.props.getStaffingLevels();
			this.closeModal();
		}
	};

	getStaffingLevelActions = (staffing_level) => (
		<Dropdown>
			<Dropdown.Toggle variant="action">
				<FiMoreHorizontal />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item
					as="button"
					onClick={() => this.openEditStaffingLevelModal(staffing_level)}
				>
					{this.props.t('common.edit')}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.cloneStaffingLevel(staffing_level.id)}
				>
					{this.props.t('staffingLevels.clone')}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.openDeleteStaffingLevelModal(staffing_level.id)}
				>
					{this.props.t('common.delete')}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			render: (staffing_level) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() => this.openEditStaffingLevelModal(staffing_level)}
				>
					{staffing_level.name}
				</button>
			),
		},
		{
			key: "description",
			header: this.props.t('common.description'),
			render: (staffing_level) =>
				staffing_level.description != null && staffing_level.description !== ""
					? staffing_level.description
					: "—",
		},
	];

	render() {
		const staffing_levels = this.props.staffing_levels || [];

		return (
			<DataTable
				tableClassName="table-staffing-levels table-hover"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getColumns()}
				rows={staffing_levels}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t('common.noResults')}
				actionsColumn={{
					render: (staffing_level) =>
						this.getStaffingLevelActions(staffing_level),
					className: "td-actions",
				}}
			/>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.groupsReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StaffingLevelList));
